"use client";

import {JSX, useEffect} from "react";

type Props = {
    error: Error & {digest?: string};
    reset: () => void;
};

export default function GlobalError({error, reset}: Props): JSX.Element {
    useEffect(() => {
        console.error("🔥 Global application crash:", error);
    }, [error]);

    return (
        <html lang="en">
            <body
                style={{
                    margin: 0,
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    background: "#0f172a",
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                }}
            >
                <div
                    style={{
                        maxWidth: 720,
                        padding: 32,
                        background: "#1e293b",
                        borderRadius: 16,
                        boxShadow: "0 10px 40px rgba(0,0,0,0.4)",
                    }}
                >
                    <h1 style={{marginTop: 0}}>🚨 Application crashed</h1>

                    <p style={{opacity: 0.8}}>A critical error occurred.</p>

                    <details
                        style={{
                            marginTop: 20,
                            padding: 16,
                            background: "#0f172a",
                            borderRadius: 8,
                            cursor: "pointer",
                        }}
                    >
                        <summary style={{fontWeight: 600}}>Error details</summary>

                        <pre
                            style={{
                                marginTop: 12,
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                color: "#f87171",
                                fontSize: 14,
                            }}
                        >
                            {error.message}
                        </pre>

                        {error.digest && (
                            <pre
                                style={{
                                    marginTop: 8,
                                    fontSize: 12,
                                    color: "#94a3b8",
                                }}
                            >
                                Digest: {error.digest}
                            </pre>
                        )}
                    </details>

                    <button
                        onClick={() => reset()}
                        style={{
                            marginTop: 24,
                            padding: "10px 18px",
                            background: "#ffffff",
                            color: "#000000",
                            borderRadius: 8,
                            border: "none",
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        Try again
                    </button>
                </div>
            </body>
        </html>
    );
}
